<template>
  <div>
    <v-layout wrap>
      <v-flex offset-md4 md4>
        <v-card>
          <v-card-title primary-title class="justify-center">
            <img height="85" src="@/assets/logo.png" />
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex md12>
                <v-text-field
                  name="username"
                  label="Usuário"
                  id="username"
                  v-model="username"
                ></v-text-field>
              </v-flex>
              <v-flex md12>
                <v-text-field
                  name="password"
                  label="Senha"
                  id="password"
                  v-model="password"
                  type="password"
                  @keydown.enter="authenticate"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="authenticate" text>Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import api from "@/api";
export default {
  data() {
    return {
      username: null,
      password: null
    };
  },
  methods: {
    authenticate() {
      api
        .request("post", "/authentication", {
          username: this.username,
          secret: this.password
        })
        .then(response => {
          this.$store.dispatch("login", {
            token: response.data.token
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if (this.$store.getters.isAuthenticated) {
      this.$router.push({ name: "home" });
    }
  }
};
</script>
